<template lang="html">
    <div class="qcode">
        <header>
            <div class="headerTitle">
            <h1>请选择模板</h1>

            <el-steps  :active="0" finish-status="success" align-center >
            <el-step title="选模板" icon="el-icon-picture"></el-step>
            <el-step title="填信息" icon="el-icon-edit"></el-step>
            <el-step title="上传" icon="el-icon-upload"></el-step>
            </el-steps>
            </div>

        </header>


          <el-radio-group v-model="CardRadio" class="el-radio-myStyle">
            <ul >
              <template v-for="cardType in cardTypeList " >
                <QrcodeTypeCard :key="'card'+cardType" :Card_type="cardType" :Card_ImgPath="`${OSS_URL}/${cardType}.jpg/${commonStyle}`"></QrcodeTypeCard>
              </template>
                <el-badge value="Beta" class="item">
                    <p>以下是彩色版测试</p>
                </el-badge>
                <QrcodeTypeCard  :Card_type="'color-2'" :Card_ImgPath="`${OSS_URL}/color-2.jpg/${commonStyle}`"></QrcodeTypeCard>
            </ul>
          </el-radio-group>
        <footer>
            <div class="footer">
                <router-link to="/WriteInfo">
                    <Button class="next_btn" :disabled="CardRadio==''" :class="{'next_btn_disabled':CardRadio==''}">
                    下一步
                </Button>
            </router-link>
            </div>
        </footer>
    </div>
</template>

<script>
import axios from "axios";
import QrcodeTypeCard from "@/components/QrcodeTypeCard.vue";
export default {
  data() {
    return {
      CardRadio: "",
      OSS_URL: this.$store.getters.get_ossURL + "/images",
      commonStyle: "middle-thumbnail",
      cardTypeList: [
        "1-1",
        "2-1",
        "2-1-1",
        "2-2",
        "2-2-1",
        "2-3",
        "2-5",
        "3-1",
        "3-1-1",
        "3-3",
        "3-4",
        "3-4-1",
        "3-6",
        "3-7",
        "4-1",
        "4-3",
        "5-1",
        "5-2",
        "5-3",
        "5-4",
        "5-5",
        "5-6",
        "D-1",
        "D-2",
        "D-3",
        "E-1",
        "E-2",
        "E-3",
      ],
    };
  },
  watch: {
    CardRadio: function (data) {
      // this.$store.state.Card_type=data;
      this.$store.dispatch("set_Card_type", data);
    },
  },
  components: {
    QrcodeTypeCard,
  },
  methods: {},
  mounted: function () {},
};
</script>

<style lang="stylus">
@import '../assets/color.styl';

a {
  text-decoration: none;
  color: color_light;
}

.headerTitle {
  background: color_light;
  color: color_Main;
  padding: 0.5em;

  h1 {
    font-weight: 200;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.next_btn {
  width: 100%;
  color: color_light;
  background: color_highlight;
  border: none;
  padding: 0.5em;
  font-size: 1.4em;
  cursor: pointer;
}

.next_btn_disabled {
  background: color_disabled !important;
}

ul {
  list-style: none;
  padding: 0;
}

.el-radio-myStyle {
  display: block !important;
  font-size: 1em !important;
  margin-bottom: 5em;
}

.el-step__icon {
  background: #f5f5f5 !important;
}
</style>



// WEBPACK FOOTER //
// SelectQcodeType.vue?19ee4fe6